'use client';

import { getStoryblokApi } from '@/lib/storyblok';
import React from 'react';

export default function StoryblokProvider({ children }: { children: React.ReactNode }) {
  getStoryblokApi();
  return children;
}
